<template>
    <div class="feedback-tech">
        <div class="form-field required">
            <div class="title">Текст обращения</div>
            <div class="value">
                    <textarea v-model="model.description"
                              :class="{ error: v.model.description.$error }"
                              class="description"
                              maxlength="2000"
                              placeholder="Подробно опишите проблему, с которой столкнулись: не открываются страницы, не работают кнопки и так далее" />
                <span class="inform">
                         <template v-if="model.description.length">
                             Осталось {{ remainingChar | pluralForm([ '%n символ', '%n символа', '%n символов' ]) }}
                         </template>
                        <template v-else>
                              Максимум 2000 символов
                        </template>
                    </span>
            </div>
        </div>

        <div class="form-field">
            <div class="title">Прикреплённые файлы</div>
            <div class="value">
                <DocumentsAdd :max-file-size="0"
                              :max-total-files-size="20"
                              :can-upload-document="false"
                              :documents.sync="model.documents"
                              class="documents-add"
                              entity-type=""
                />
            </div>
        </div>

        <div class="form-field">
            <div class="value info">
                По вопросам работоспособности сайта можно обратиться в техническую поддержку
                <a href="https://helpme.rt.ru/tickets/create/otrs1/3806"
                   target="_blank">
                    Helpme
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import DocumentsAdd from '@/common/page_comp/Documents/DocumentsAdd.vue';
import { equals, updateState } from '@/common/util/util.js';
import { TITLE_SITE } from '@/config.js';
import { sendSupport } from '@/restapi/support.js';
import { useVuelidate } from '@vuelidate/core';
import { maxLength, required } from '@vuelidate/validators';

const emptyModel = () => ({
    description: '',
    theme: 'Территория цифровых решений',
    documents: [],
});

export default {
    name: 'FeedbackTech',
    setup() {
        return {
            v: useVuelidate({ $autoDirty: true }),
        };
    },
    components: { DocumentsAdd },
    data() {
        return {
            model: emptyModel(),
        };
    },
    validations() {
        return {
            model: {
                description: {
                    required,
                    maxLength: maxLength(2000),
                },
            },
        };
    },
    computed: {
        remainingChar() {
            return 2000 - this.model.description.length;
        },
    },
    created() {
        this.reset();
    },
    methods: {
        setInnerState(newModel) {
            updateState(this.model, newModel);
        },
        reset() {
            Object.assign(this.model, emptyModel());
            this.model.theme = TITLE_SITE;
        },
        async save() {
            await sendSupport({
                ...this.model,
            });
        },
    },
    watch: {
        model: {
            deep: true,
            handler(value) {
                const changed = !equals(value.description, emptyModel().description) ||
                    !equals(value.documents, emptyModel().documents);
                this.$emit('changed', changed);
            },
        },
    },
};
</script>


<style lang="scss" scoped>
.feedback-tech {
    .description {
        resize: vertical;
        min-height: 88px;
        color: var(--text-color);
        font-size: var(--text-font-size);
        line-height: var(--text-line-height);
    }

    .inform {
        color: var(--input-placeholder-color);
        font-size: 12px;
    }

    .info {
        border-top: 1px solid rgba(16, 24, 40, 0.25);
        padding-top: 8px;
        color: var(--label-color);
    }
}
</style>
